import { useState, useImperativeHandle, useRef } from "react";
import styles from "../InputField/InputField.module.scss";
import clsx from "clsx";

type TextBoxProps = {
    icon?: string;
    type?: string;
    maxLength?: number;
    containerClass?: string;
    ref?: React.RefObject<HTMLInputElement | null>;
    size?: "small";
    [key: string]: unknown;
}

const InputField: React.FC<TextBoxProps> = ({ containerClass, icon, maxLength, type, ref, size, ...otherProps }: TextBoxProps) => {

    const [showPassword, setShowPassword] = useState(false);
    const inputRef = useRef<HTMLInputElement | null>(null);

    useImperativeHandle(ref, () => inputRef.current!);


    const toggleVisibility = () => {
        setShowPassword((prev) => !prev);
    };
    const isPassword = type === "password";
    const isReadOnly = otherProps.readOnly === true;

    return (
        <div
            className={clsx(
                styles.inputWrapper,
                styles[String(size)],
                isReadOnly && styles.readOnlyWrapper,
                size === "small" ? "mt-1.5" : "mt-4",
                containerClass
            )}
        >
            {icon && <img src={icon} alt="icon" className={styles.icon}></img>}

            <input {...otherProps}
                type={isPassword ? (showPassword ? "text" : "password") : type}
                className={clsx(styles.input, styles[String(size)])}
                maxLength={maxLength}
                ref={inputRef}
            />

            {isPassword && (otherProps.value as string)?.length > 0 && (
                <span onClick={toggleVisibility} className={`${styles.visibilityIcon} material-icons`} >
                    {showPassword ? "visibility_off" : "visibility"}
                </span>
            )}
        </div>
    )
}
export default InputField;